export default __webpack_public_path__ + "static/media/creator-iv-audio@2x.fbdf759a.png";